import React from 'react';
import { UserChatContainer, UserChatMessage } from './styled';

function UserChat({userMsg}) {
  return (
    <UserChatContainer>
      <UserChatMessage>{userMsg}</UserChatMessage>
    </UserChatContainer>
  )
}

export default UserChat;